import React from 'react'
import { Link } from 'react-router-dom'

// Tranlations
import t from '../../../translations'

export default function Footer(props) {
    return (
        <div className='footer'>
            <hr />
            <>
                <span className='footerLink'>
                    <Link to='/privacy'>{t[props.lang].specifics_footerPrivacy['page title']}</Link>
                </span>
                |
                <span className='footerLink'>
                    <Link to='/delete-my-account'>{t[props.lang].specifics_footerDeleteAccount['page title']}</Link>
                </span>
            </>
        </div>
    )
}